import { Paper, Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Select, MenuItem, Radio, Button } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";

const TxqTopupDialog = ({ open, onClose, onFinish, user }) => {
  const [form, setForm] = useState({
    type: "PLUS", // 充值类型
    remark: "",
    amount: "",
    password: "",
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert("数量不能为空");

    const { msg } = await asyncRequest({
      path: "/user/changeTxq",
      data: {
        uid: user.uid,
        ...form,
      },
    });

    alert(msg, "success");
    onFinish();
  }

  return (
    <FormDialog title="修改添星券" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户">
        <UserInfo {...user} />
      </FormItem>

      <FormItem title="变化">
        <RadioGroup row name="row-radio-buttons-group" value={form.type} onChange={(e) => handleIptChange("type", e.target.value)}>
          <FormControlLabel value={"PLUS"} control={<Radio />} label="增加" />
          <FormControlLabel value={"MINUS"} control={<Radio />} label="减少" />
          {/* <FormControlLabel value={'FINAL'} control={<Radio />} label="最终积分" /> */}
        </RadioGroup>
      </FormItem>

      <FormItem title="充值数目">
        <TextField fullWidth type="number" placeholder="充值数目" autoComplete="off" id="amount" value={user.amount} size="small" onChange={(e) => handleIptChange("amount", e.target.value)} />
      </FormItem>

      <FormItem title="密码" required>
        <TextField fullWidth placeholder="密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth placeholder="备注" autoComplete="off" id="remark" value={user.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default TxqTopupDialog;
